import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { PencilIcon } from 'components/icons';
import { ButtonsProps } from '../types';

export const EditButton: FC<ButtonsProps> = (props) => {
  const { t } = useTranslation('translation');

  return (
    <Button type="text" icon={<PencilIcon />} {...props}>
      {t('Edit')}
    </Button>
  );
};
